
const SpecIcon = ({ icon }) => {
    return (
        <div className="rounded-full grid items-center justify-center w-11 max-md:w-5 p-1 aspect-square bg-[#3462C1] mr-5 max-md:mr-2">
            {icon}
        </div>
    )
}

const MoedaFormatada = ({ valor }) => {
    // Certifique-se de que o valor é um número
    const numero = typeof valor === 'number' ? valor : parseFloat(valor);

    // Formatando como moeda
    const moedaFormatada = numero.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

    return <span>{moedaFormatada}</span>;
};

export {SpecIcon, MoedaFormatada};